module.exports = __webpack_public_path__ + "img/word of mouth.d401f9be.svg";